import { Admission } from '@domain/admission';

export const shouldFilterOfferIfIsSiae = (selectedOffer: Admission, isSiaeImportLimited: boolean) =>
  selectedOffer?.settings.italyRegulation
    ? selectedOffer?.settings.italyRegulation?.isSiaeExcluded ||
      (selectedOffer?.settings.italyRegulation?.isSiaeApproved && !isSiaeImportLimited)
    : true;
